export const emptyQueryBuilderQuery = {
  rules: [],
  combinator: 'and',
}
